<template>
  <div>
    <div class="chart-title">PL/DD/RU</div>
    <div class="settings-button">
      <miniSettings :position="position" :minis="minis" />
    </div>
    <apexchart
      class="mb-4"
      v-if="data != null"
      ref="minichartEquity"
      type="line"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <div class="width-full float-left text-center text-grey no-trades" v-else>NO TRADES</div>
  </div>
</template>

<script>
import miniSettings from "./miniSettings";
export default {
  name: "MiniEquity",
  components: { miniSettings },
  props: ["data", "source"],
  data() {
    return {
      miniType: { Strategies: "minichartsStrategy", Tags: "minichartsTag" },
      chartOptions: {
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top"
            },
            stroke: 0,
            columnWidth: "95%",
            distributed: false,
            colors: {
              ranges: [
                {
                  from: 0,
                  to: 999999,
                  color: "#79C04D"
                },
                {
                  from: -999999,
                  to: -1,
                  color: "#E62163"
                }
              ]
            }
          }
        },
        legend: {
          labels: {
            colors: undefined,
            useSeriesColors: true
          }
        },
        xaxis: {
          labels: {
            show: false
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          enabled: false
        },
        grid: {
          show: false
        },
        colors: ["#79C04D", "#b6c1cb", "#E62163"],
        chart: {
          toolbar: {
            show: false
          }
        },
        stroke: {
          show: true,
          //curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: [3, 0, 3],
          dashArray: 0
        }
      },
      series: []
    };
  },
  watch: {
    data: function() {
      this.equityData();
    }
  },
  mounted() {
    this.equityData();
  },
  methods: {
    equityData() {
      this.$refs.minichartEquity.updateSeries([
        { data: this.data.RUs, name: "RU" },
        { data: this.data.PLs, name: "PL", type: "column" },
        { data: this.data.DDs, name: "DD" }
      ]);
      //this.colorSet(this.equity[this.equity.length - 1]);
    },
    colorSet(val) {
      if (val > 0) {
        // green
        this.$refs.minichartEquity.updateOptions({ colors: ["#79C04D"] });
      } else {
        //red
        this.$refs.minichartEquity.updateOptions({ colors: ["#E62163"] });
      }
    }
  }
};
</script>

<style>
</style>